import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { OrderDirection } from '#features/api/types';
import { getBlogPosts } from '#features/blog/model/blog';

export const useBlogPostsPagination = (tag?: string) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery({
    queryKey: ['blogPosts'],
    queryFn: ({ pageParam = 0 }) =>
      getBlogPosts({
        offset: pageParam * 100,
        limit: 100,
        orders: [{ direction: OrderDirection.DESC, field: 'date' }],
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.hasMore) {
        return undefined;
      }
      return allPages.length;
    },
    select: (data) => {
      const allPosts = data?.pages?.flatMap((page) => page.records) ?? [];
      if (!tag) return allPosts;
      return allPosts.filter((post) =>
        post.tags
          ?.split(',')
          .some((t) => t.trim().toLowerCase() === tag.toLowerCase()),
      );
    },
  });

  const loadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetching]);

  return { items: data ?? [], isLoading, loadMore };
};
